/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { platformMcpRecordDashboardCtaEvent } from "../funcs/platformMcpRecordDashboardCtaEvent.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  RecordPlatformMCPDashboardCtaEventRequest,
  RecordPlatformMCPDashboardCtaEventSecurity,
} from "../models/operations/recordplatformmcpdashboardctaevent.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RecordPlatformMCPDashboardCtaEventMutationVariables = {
  request: RecordPlatformMCPDashboardCtaEventRequest;
  security?: RecordPlatformMCPDashboardCtaEventSecurity | undefined;
  options?: RequestOptions;
};

export type RecordPlatformMCPDashboardCtaEventMutationData = void;

export type RecordPlatformMCPDashboardCtaEventMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * recordDashboardCtaEvent platformMcp
 *
 * @remarks
 * Record a bounded Platform MCP dashboard CTA impression, selection, or dismissal.
 */
export function useRecordPlatformMCPDashboardCtaEventMutation(
  options?: MutationHookOptions<
    RecordPlatformMCPDashboardCtaEventMutationData,
    RecordPlatformMCPDashboardCtaEventMutationError,
    RecordPlatformMCPDashboardCtaEventMutationVariables
  >,
): UseMutationResult<
  RecordPlatformMCPDashboardCtaEventMutationData,
  RecordPlatformMCPDashboardCtaEventMutationError,
  RecordPlatformMCPDashboardCtaEventMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRecordPlatformMCPDashboardCtaEventMutation(client, options),
    ...options,
  });
}

export function mutationKeyRecordPlatformMCPDashboardCtaEvent(): MutationKey {
  return ["@gram/client", "platformMcp", "recordDashboardCtaEvent"];
}

export function buildRecordPlatformMCPDashboardCtaEventMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RecordPlatformMCPDashboardCtaEventMutationVariables,
  ) => Promise<RecordPlatformMCPDashboardCtaEventMutationData>;
} {
  return {
    mutationKey: mutationKeyRecordPlatformMCPDashboardCtaEvent(),
    mutationFn: function recordPlatformMCPDashboardCtaEventMutationFn({
      request,
      security,
      options,
    }): Promise<RecordPlatformMCPDashboardCtaEventMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(platformMcpRecordDashboardCtaEvent(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
